import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "trial-consent"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { ref, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { submitLead } from '@/api/lead';
export default {
  __name: 'TrialDialog',
  props: {
    modelValue: Boolean
  },
  emits: ['update:modelValue', 'closed'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: value => emit('update:modelValue', value)
    });
    const form = ref({
      name: '',
      phone: '',
      sex: '',
      email: '',
      age: null,
      text: ''
    });
    const formRef = ref(null);
    const rules = {
      name: [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      }],
      phone: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      }, {
        pattern: /^1[3-9]\d{9}$/,
        message: '请输入正确的手机号',
        trigger: 'blur'
      }],
      sex: [{
        required: false,
        message: '请选择性别',
        trigger: 'change'
      }],
      age: [{
        required: false,
        message: '请输入年龄',
        trigger: 'change'
      }],
      email: [{
        required: false,
        message: '请输入邮箱',
        trigger: 'blur'
      }, {
        type: 'email',
        message: '请输入正确的邮箱地址',
        trigger: 'blur'
      }],
      text: {
        required: false,
        message: '请输入备注',
        trigger: 'change'
      }
    };
    const submitForm = async () => {
      if (!formRef.value) return;
      await formRef.value.validate(async valid => {
        if (!valid) {
          ElMessage.warning('请填写必要的信息');
          return false;
        }

        /* 接口地址统一收在 src/api/lead.js，和页脚留言共用同一入口 */
        await submitLead({
          name: form.value.name,
          phone: form.value.phone,
          email: form.value.email,
          sex: form.value.sex,
          age: form.value.age,
          text: form.value.text
        }).then(response => {
          const res = response.data;
          if (res.status !== 'error') {
            ElMessage.success('提交成功！');
            formRef.value.resetFields();
            dialogVisible.value = false;
          } else {
            ElMessage.error('提交失败，请重试');
          }
        }).catch(error => {
          console.error(error);
          ElMessage.error('网络出错，请重试');
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dialogVisible.value = $event),
        width: "500",
        title: "申请体验",
        onClosed: _cache[9] || (_cache[9] = $event => _ctx.$emit('closed')),
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
              placeholder: "请输入您的姓名"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号",
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.phone = $event),
              placeholder: "请输入您的手机号"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "性别",
            prop: "sex"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.value.sex,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.sex = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: "男"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("男")])),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: "女"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("女")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "年龄",
            prop: "age"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              min: 0,
              max: 200,
              modelValue: form.value.age,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.age = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "邮箱",
            prop: "email"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.email = $event),
              placeholder: "请输入您的邮箱"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "text"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.text,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.text = $event),
              type: "textarea",
              placeholder: "请在这里输入其它您想告诉我们的"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createElementVNode("p", _hoisted_1, [_cache[13] || (_cache[13] = _createTextVNode(" 提交即表示你已阅读并同意 ")), _createVNode(_component_router_link, {
            to: "/privacy",
            onClick: _cache[6] || (_cache[6] = $event => dialogVisible.value = false)
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("《隐私政策》")])),
            _: 1
          })])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};